export default __webpack_public_path__ + "static/media/rightsvg.286f4067.svg";